module.exports = __webpack_public_path__ + "static/media/back-button.6c14c306.svg";